// Class: haxe.iterators.StringKeyValueIterator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
function StringTools() {return require("./../../StringTools");}

// Constructor

var StringKeyValueIterator = function(s) {
	this.offset = 0;
	this.s = s;
}

// Meta

StringKeyValueIterator.__name__ = "haxe.iterators.StringKeyValueIterator";
StringKeyValueIterator.__isInterface__ = false;
StringKeyValueIterator.prototype = {
	hasNext: function() {
		return this.offset < this.s.length;
	},
	next: function() {
		return { key : this.offset, value : (StringTools().default).fastCodeAt(this.s,this.offset++)};
	}
};
StringKeyValueIterator.prototype.__class__ = StringKeyValueIterator.prototype.constructor = $hxClasses["haxe.iterators.StringKeyValueIterator"] = StringKeyValueIterator;

// Init



// Statics




// Export

exports.default = StringKeyValueIterator;